import { Auth } from '@aws-amplify/auth';

export const ForgotPassword = async ({ username }: { username: string }): Promise<boolean> => {
  await Auth.forgotPassword(username).catch((err) => {
    if (err.code === 'UserNotFoundException') {
      throw new Error('Username not found.');
    }

    if (err.code === 'LimitExceededException') {
      throw new Error('Password reset attempt limit exceeded. Please try again after some time.');
    }

    if (
      err.code === 'InvalidParameterException' &&
      err.message === 'Cannot reset password for the user as there is no registered/verified email or phone_number'
    ) {
      throw new Error('Email not yet confirmed');
    }

    console.error({ action: 'onNotReceived:Auth.forgotPassword:error', error: err });
    throw new Error('Could not send verification code.');
  });

  return true;
};

export const ResendConfirmationCode = async ({ email }: { email: string }): Promise<boolean> => {
  await Auth.resendSignUp(email).catch((err) => {
    console.error({ action: 'Auth:resendSignUp:error', error: err });
    throw new Error('Could not send confirmation code.');
  });

  return true;
};
